$( document ).ready(function() {
    var lang = document.documentElement.lang;
  $('.btn-no-tickets').qtip({
      content: lang == "hu" ? 'Az előadásra minden jegy elfogyott!' : 'Sold out',
      prerender: true,
      style: { classes: 'qtip-dark' },
      position: { my: 'bottom left', target: 'mouse', adjust: { x: 5, y: 5 }, position: { viewport: $(window) } },
  }).click(function() { return false; });
  // Video overlays
  // Video overlays
    $('#vo').lightGallery();
});

$(function() {

    var lang = document.documentElement.lang;

    var c = getCookie('popup-1206');

    var currentUrl = window.location.pathname;
    var disabledUrl = [
        '/',
        '/en',
        '/jegyek',
        '/en/tickets',
        '/eloszo-1',
        '/en/preface-1',
        '/aktualis',
        '/en/news',
        '/program/eloadasok',
        '/en/programme/performances',
        '/program/musornaptar',
        '/en/programme/calendar',
        '/gyik',
        '/en/faq'
    ];

    // if ( (c == '' || c == undefined || c == null) && disabledUrl.indexOf(currentUrl) != -1) {
    //     $('.modal-popup').addClass('showme');
    // }
    //
    //
    //  setCookie('popup-1206', ''); 
    $('.popup-close').on('click', function() {
        $('.modal-popup').removeClass('showme');
        setCookie('popup-1206', true);
        var page = (lang == 'hu' ? "archivum" : "en/archive");
        var url = "/" + page + "/2019";
        window.location.href = url;
    });

    $('.archive-button').on('click', function() {
        var page = (lang == 'hu' ? "archivum" : "archive");
        var url = "/" + page + "/2019";
        window.location.href = url;
    });

	/* Dropdown menu */
    $('ul.main-navigation li > a').click(function(e) {
        if ($(this).attr('href') == '#') {
            e.preventDefault();
            $(this).parent('li').toggleClass('open');
            $(this).parent('li').find('ul.dropdown').slideToggle(100);
        }
    });

    $('.menu-toggler').click(function(e) {
        e.preventDefault();
        $('.main-navigation').slideToggle(250);
    });

    $('a.scroll').click(function(e) {
        if ($(this).attr('data-target') !== '') {
            e.preventDefault();
            if ($(window).width() > 799) {
                $('html, body').animate({ scrollTop: $('#' + $(this).attr('data-target')).offset().top - 90 }, 250);
            } else {
                $('html, body').animate({ scrollTop: $('#' + $(this).attr('data-target')).offset().top - 130 }, 250);
            }
        }
    });

    $('.jump-top').click(function(e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 400);
    });

});

/* Sticky calendar nav */
if ($('#show-calendar .heading').length != 0) {
    var nav_offset = $('#show-calendar .heading').offset().top;
    $(window).scroll(function(e) {
        if ($(window).scrollTop() > nav_offset) {
            $('#show-calendar .heading').addClass('sticky');
        } else {
            $('#show-calendar .heading').removeClass('sticky');
        }
    });
}

function setCookie(name, value, days) {

	// expire
	var now = new Date();
	var time = now.getTime();
	time += 1000 * 3600 * 24 * days; // x days
	now.setTime(time);

	var c_value = escape(value);

	document.cookie = name + "=" + c_value + ';path=/;expires=' +now.toGMTString() +';';

};

function getCookie(name) {

	var i, x, y;
	var a;

	a = document.cookie.split(";");

	for (i = 0; i < a.length; i++) {

		x = a[i].substr(0, a[i].indexOf("="));
		y = a[i].substr(a[i].indexOf("=") + 1);
		x = x.replace(/^\s+|\s+$/g, "");

		if (x == name) {
			return unescape(y);
		}

	}



};
